export const SKIP_THRESHOLD = {
  MIN_TYPED_USER_TURNS: 1,
  MIN_USER_TURNS_OR_ATTACHMENTS: 2,
} as const;

export const ATTACHMENT_LIMITS = {
  PDF_MAX: 3,
  IMAGE_MAX: 1,
} as const;

export interface SkipIntakeInput {
  typedUserTurns: number;
  totalUserTurns: number;
  attachmentCount: number;
}

export interface SkipIntakeResult {
  canSkip: boolean;
  reason: string | null;
}

export const canSkipIntake = (input: SkipIntakeInput): SkipIntakeResult => {
  const { typedUserTurns, totalUserTurns, attachmentCount } = input;

  if (typedUserTurns < SKIP_THRESHOLD.MIN_TYPED_USER_TURNS) {
    return { canSkip: false, reason: "pages.chat.skipReasonMinTyped" };
  }

  if (totalUserTurns < SKIP_THRESHOLD.MIN_USER_TURNS_OR_ATTACHMENTS && attachmentCount < 1) {
    return {
      canSkip: false,
      reason: "pages.chat.skipReasonMoreNeeded",
    };
  }

  return { canSkip: true, reason: null };
};
